import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams, HttpErrorResponse} from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {User} from '../_models/user.model';
import {SocialAuthService} from 'angularx-social-login';


@Injectable({providedIn: 'root'})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  longitude: number = 0.0;
  latitude: number = 0.0;

  constructor(private http: HttpClient
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    if (this.currentUserSubject) {
      return this.currentUserSubject.value;
    } else {
      return null;
    }
  }

  register(loginPayLoad) {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    return this.http.post<any>(environment.apiUrl + '/register', loginPayLoad, httpOptions);
  }

  loginByOtp(loginPayLoad) {
    return this.http.post<any>(environment.apiUrl + '/verifyotp', loginPayLoad).pipe(
      map(data => {
        if (data.error) {
          return data;
        }
        if (data.type == "error") {
          return data;
        }
        this.setLoginStorage(data);
        return data;
      }));
  }

  socialLogin(provider, userData) {
    return this.http.get<any>(`${environment.apiUrl}/social/callback/${provider}/${userData.authToken}`).pipe(
      map(data => {
        if (data.error) {
          return data;
        }
        this.setLoginStorage(data);
        return data;
      }));
  }

  setLoginStorage(data) {
    var localUser = data.profile;
    localUser.accessToken = data.access_token;
    localStorage.setItem('currentUser', JSON.stringify(localUser));
    this.currentUserSubject.next(localUser);
    /**
     * to be removed after optmization*/
    localStorage.setItem('accessToken', data.access_token);
    localStorage.setItem('first_name', data.profile.first_name);
    localStorage.setItem('last_name', data.profile.last_name);
    localStorage.setItem('mobile_number', data.profile.mobile_number);
  }

  updateLoginStorage(data) {
    var current = this.currentUserSubject.value;
    if (current) {
      current.first_name = data.first_name;
      current.last_name = data.last_name;
      current.city = data.city;
      current.mobile_number = data.mobile_number;
      current.email = data.email;
      current.user_has_profile = data.user_has_profile;
      localStorage.setItem('currentUser', JSON.stringify(current));
      this.currentUserSubject.next(current);
      /**
       * to be removed after optmization*/
      localStorage.setItem('first_name', data.first_name);
      localStorage.setItem('last_name', data.last_name);
      localStorage.setItem('city', data.city);
      localStorage.setItem('mobile_number', data.mobile_number);
    }
  }

  logout() {
    this.currentUserSubject.next(null);
    localStorage.removeItem('currentUser');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    localStorage.removeItem('city');
    localStorage.removeItem('mobile_number');
  }


}
